export const SectionTag = ({ number, label, color = "bg-cyan" }) => (
  <div
    data-testid={`section-tag-${label.toLowerCase().replace(/\s+/g, "-")}`}
    className={`inline-flex items-center gap-2 rounded-full border-2 border-ink px-4 py-1.5 text-xs font-extrabold uppercase tracking-[0.18em] text-ink shadow-hard-sm ${color}`}
  >
    <span className="font-display text-sm tracking-normal">{number}</span>
    <span>{label}</span>
  </div>
);
